import routesAllowed, {UNAUTHENTICATED} from "../redux/routesAllowed";

export default (route, role) =>
    routesAllowed[role] ? routesAllowed[role].includes(route) : routesAllowed[UNAUTHENTICATED].includes(route);
